import {
  Swiper,
  FreeMode,
  Mousewheel,
  Navigation,
} from 'swiper';

function setNavDisabled(btn, isDisabled) {
  btn.classList.toggle('disabled', isDisabled);
  btn.toggleAttribute('disabled', isDisabled);
  btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
}

function updateAccessibility(swiper, focusableElement) {
  if (!focusableElement) {
    return;
  }

  const { isLocked } = swiper;

  if (isLocked) {
    focusableElement.removeAttribute('tabindex');
    focusableElement.removeAttribute('role');
  } else {
    focusableElement.setAttribute('tabindex', '0');
    focusableElement.setAttribute('role', 'region');
  }
}

function updateNavState(swiper, prevEl, nextEl) {
  if (!prevEl || !nextEl) {
    return;
  }

  const isDisabled = swiper.isLocked;
  setNavDisabled(prevEl, isDisabled || swiper.isBeginning);
  setNavDisabled(nextEl, isDisabled || swiper.isEnd);
}

function updateFocusWidth(swiper, swiperWrapper) {
  if (!swiperWrapper) {
    return;
  }

  swiperWrapper.style.setProperty('--slider-total-width', `${swiper.virtualSize + 4}px`);
}

function syncSwiperState(swiper, {
  swiperContainer,
  swiperWrapper,
  prevEl,
  nextEl,
}) {
  // eslint-disable-next-line no-param-reassign
  swiper.allowTouchMove = !swiper.isLocked;
  swiperContainer.classList.toggle('swiper-grab-cursor', !swiper.isLocked);
  updateAccessibility(swiper, swiperWrapper);
  updateNavState(swiper, prevEl, nextEl);
  updateFocusWidth(swiper, swiperWrapper);
}

function initCarouselCrestBlock(block) {
  const swiperContainer = block.querySelector('.carousel-crest__swiper.swiper');

  if (!swiperContainer) {
    return;
  }

  const carouselArea = block.querySelector('.carousel-crest__carousel');
  const prevEl = block.querySelector('.carousel-crest__nav--prev');
  const nextEl = block.querySelector('.carousel-crest__nav--next');
  const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
  const state = {
    swiperContainer,
    swiperWrapper,
    prevEl,
    nextEl,
  };

  if (swiperContainer.swiper) {
    swiperContainer.swiper.destroy(true, true);
  }

  const swiperInstance = new Swiper(swiperContainer, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    loop: false,
    initialSlide: 0,
    modules: [FreeMode, Mousewheel, Navigation],
    grabCursor: true,
    watchOverflow: true,
    mousewheel: {
      enabled: true,
      forceToAxis: false,
      releaseOnEdges: true,
      sensitivity: 1,
      eventsTarget: carouselArea || swiperContainer,
    },
    freeMode: {
      enabled: true,
      momentum: isTouchDevice,
      momentumBounce: false,
      momentumRatio: isTouchDevice ? 1.15 : 0.6,
      momentumVelocityRatio: isTouchDevice ? 1.2 : 0.75,
    },
    touchRatio: isTouchDevice ? 1.25 : 1,
    threshold: isTouchDevice ? 4 : 8,
    touchReleaseOnEdges: true,
    touchStartPreventDefault: false,
    navigation: prevEl && nextEl ? {
      prevEl,
      nextEl,
    } : undefined,
    on: {
      init: (swiper) => syncSwiperState(swiper, state),
      resize: (swiper) => {
        requestAnimationFrame(() => {
          swiper.update();
          syncSwiperState(swiper, state);
        });
      },
      slidesLengthChange: (swiper) => syncSwiperState(swiper, state),
      slideChange: (swiper) => updateNavState(swiper, prevEl, nextEl),
    },
  });

  swiperContainer.carouselCrestSwiper = swiperInstance;

  swiperContainer.addEventListener('keydown', (e) => {
    if (swiperInstance.isLocked) {
      return;
    }

    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();

      if (e.key === 'ArrowRight') {
        swiperInstance.slideNext();
      } else {
        swiperInstance.slidePrev();
      }
    }
  });
}

export default function initCarouselCrestSlider() {
  document.querySelectorAll('.carousel-crest').forEach(initCarouselCrestBlock);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/carousel-crest', () => {
      initCarouselCrestSlider();
    });
  } else {
    initCarouselCrestSlider();
  }
});
